// extracted by mini-css-extract-plugin
module.exports = {"AvatarLoader":"AvatarLoader_AvatarLoader__2Dkf-","lds-ring":"AvatarLoader_lds-ring__2pvBP"};